(() => {
  // Delegation survives Shopify section replacement in the theme editor.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mutt-fit-trigger]');
    if (!trigger) return;
    const guide = document.getElementById(trigger.dataset.muttFitTrigger);
    if (!guide) return;
    if (typeof guide.showModal === 'function') guide.showModal();
    else guide.setAttribute('open', '');
    guide.querySelector('[data-mutt-fit-close]')?.focus({ preventScroll: true });
  });
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-mutt-fit-close]');
    if (close) close.closest('dialog')?.close();
    const unit = event.target.closest('[data-mutt-unit]');
    if (unit) {
      const dialog = unit.closest('.mutt-size-chart');
      dialog.querySelectorAll('[data-mutt-unit]').forEach((button) => button.classList.toggle('is-active', button === unit));
      dialog.querySelectorAll('[data-mutt-chart]').forEach((chart) => { chart.hidden = chart.dataset.muttChart !== unit.dataset.muttUnit; });
    }
  });
  document.addEventListener('click', (event) => {
    if (event.target.matches('.mutt-size-chart')) event.target.close();
  });
  const observers = new Map();
  function initialize(root = document) {
    root.querySelectorAll('[data-mutt-sticky]').forEach((bar) => {
      if (observers.has(bar) || !('IntersectionObserver' in window)) return;
      const target = document.getElementById(bar.dataset.muttSticky);
      if (!target) return;
      const observer = new IntersectionObserver(([entry]) => {
        // Appear only after shoppers have scrolled past purchase controls.
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
      observer.observe(target);
      observers.set(bar, observer);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [bar, observer] of observers) {
      if (event.target.contains(bar)) { observer.disconnect(); observers.delete(bar); }
    }
  });
})();
